import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-safe-svg-icon',
    templateUrl: 'duotone-safe-svg-icon.component.html',
    standalone: false
})

export class DuotoneSafeSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
